import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { budgetBuilderSelectors, tenantSelectors } from "store/selectors";
import {
	getCostShareSubtotal,
	getLineItemsDirectCostTotal,
	getPeriodSubtotal,
	getTotalFACostsByPeriod,
} from "utils/budgetBuilder";

import styles from "./styles.css";


export const OverviewTotalCosts = () => {
	const periodList = useSelector(budgetBuilderSelectors.periodRows);
	const externalCostShareByPeriod = useSelector(budgetBuilderSelectors.externalCostShareByPeriod);
	const internalCostShareByPeriod = useSelector(budgetBuilderSelectors.internalCostShareByPeriod);
	const sponsoredCostsByPeriod = useSelector(budgetBuilderSelectors.sponsoredCostsByPeriod);
	const researchTeamByPeriod = useSelector(budgetBuilderSelectors.researchTeamByPeriod);
	const { subawardCostCap } = useSelector(tenantSelectors.tenant);
	const { currencyFormatter } = useTenantFormatter();

	const totalCosts = useMemo(() => {
		const faCostsByPeriod = getTotalFACostsByPeriod(
			sponsoredCostsByPeriod,
			subawardCostCap,
			researchTeamByPeriod,
			periodList
		);
		let result = [];
		for (let period of periodList) {
			let periodTotal = 0;
			periodTotal += getLineItemsDirectCostTotal(sponsoredCostsByPeriod?.[period?.periodNumber]);
			periodTotal += getPeriodSubtotal(researchTeamByPeriod?.[period?.periodNumber], false);
			periodTotal += getPeriodSubtotal(researchTeamByPeriod?.[period?.periodNumber], true);
			periodTotal += faCostsByPeriod[period.periodNumber];
			periodTotal += getCostShareSubtotal(internalCostShareByPeriod?.[period?.periodNumber]);
			periodTotal += getCostShareSubtotal(externalCostShareByPeriod?.[period?.periodNumber]);
			result.push(periodTotal);
		}

		return result;
	},
	[
		externalCostShareByPeriod,
		internalCostShareByPeriod,
		periodList,
		researchTeamByPeriod,
		sponsoredCostsByPeriod,
		subawardCostCap
	]);

	const total = useMemo(
		() => totalCosts.reduce((previous, current) => previous + current, 0),
		[ totalCosts ]
	);


	return (
		<Table.Row className={`${styles.rowHeader} ${styles.totalRowDivider}`}>
			<Table.Cell className={`${styles.cellAlignLeft} ${styles.rowHeaderCell}`}>
				<span className={styles.bold}>{"Total Project Cost"}</span>
			</Table.Cell>
			{totalCosts?.map((costForPeriod, i) => (
				<Table.Cell className={`${styles.cellAlignRight} ${styles.rowHeaderCell}`} key={`period-${i}`}>
					<span className={styles.bold}>{currencyFormatter(costForPeriod)}</span>
				</Table.Cell>
			))}
			<Table.Cell className={`${styles.cellAlignRight} ${styles.rowHeaderCell}`}>
				<span className={styles.bold}>{currencyFormatter(total)}</span>
			</Table.Cell>
		</Table.Row>
	);
};
